
// ********* Import CSS ***************** //

import "./enc-words-popup.css";

// ********* Import Wordmark ***************** //

// ** GCS Wordmark ** //
// import "/src/assets/logos/gcs-wordmark-code-pink.png";

// ************************************************* Encouraging Words ***************************************** //

class EncouragePopup extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

    <div id="words-modal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        
        <div class="modal-content">


          <!-- ******* BEGIN: MODAL HEADER (Image, Title, X button) ******* -->

          <div class="modal-header row col-12 d-flex justify-content-auto px-0 mx-auto">

            <div class="row col-12 px-0 mx-auto">

                <div class="row col-11">
                    <img src="assets/logos/gcs-wordmark-code-pink.png" class="modal-logo model-title" alt="Girls Code Savannah wordmark"/>
                </div>

                <div class="row col-1">
                    <p id="words-close" class="pt-2 bold text-purple text-center" data-bs-dismiss="modal" aria-label="Close">X</p>
                </div>

            </div>

            <div class="row col-12 mt-2 mb-2">
                <p class="modal-title font-oswald text-purple text-start">Leave Encouraging Words</p>
            </div>
        
          </div>

          <!-- ******* END: MODAL HEADER (Image, Title, X button) ******* -->


          <!-- ******* BEGIN: MODAL BODY/FORM ******* -->

          <div class="modal-body pt-0">

            <form id="wordsForm" action="" name="wordsForm" class="mx-auto">


                <!-- First & Last Name -->

                <div class="name-row row mt-0 px-0">

                  <div class="col-6 form-group">
                    <label for="firstName" class="font-oswald col-form-label text-dark-blue text-size-h3 ps-1">First Name<span class="text-hot-pink text-size-h2">&#42;</span></label>
                    <input type="text" class="form-control" id="firstName" name="firstName" placeholder="Enter First Name" aria-label="Enter first name" required>
                  </div>

                  <div class="col-6 form-group">
                    <label for="lastName" class="font-oswald col-form-label text-dark-blue text-size-h3 ps-1">Last Name<span class="text-hot-pink text-size-h2">&#42;</span></label>
                    <input type="text" class="form-control" id="lastName" name="lastName" placeholder="Enter Last Name" required>
                  </div>

                </div> <!-- name-row -->


                <!-- BEGIN: City & State -->

                <div class="city-state-row row mt-2 px-0">

                  <div class="col-6 form-group">
                    <label for="city" class="font-oswald col-form-label text-dark-blue text-size-h3 ps-1">City<span class="text-hot-pink text-size-h2">&#42;</span></label>
                    <input type="text" class="form-control" id="city" name="city" placeholder="Enter City" required>
                  </div>

                  <div class="col-6 form-group">

                    <label for="state" class="font-oswald col-form-label text-dark-blue text-size-h3 ps-1">State or Country<span class="text-hot-pink text-size-h2">&#42;</span></label>
                        
                    <select class="form-control" id="state" name="state" required>

                      <option value="">Select...</option> 

                      <states-countries></states-countries>          

                    </select>

                  </div>

                </div>

                <!-- END: City & State -->


                <!-- Title -->

                <div class="form-group mt-2 px-0">
                  <label for="title" class="font-oswald col-form-label text-dark-blue text-size-h3 ps-1">Your Title</label>
                  <input type="text" class="form-control" id="title" name="title" placeholder="Enter Your Title">
                  <span class="ps-1 text-size-h5 pb-2">(<span class="bold">Note:</span> Proud Parent or Grandparent is a great title too!)</span>
                </div>


                <!-- Company -->

                <div class="form-group mt-2 px-0">
                  <label for="company" class="font-oswald col-form-label text-dark-blue text-size-h3 ps-1">Company, Organization, or School</label>
                  <input type="text" class="form-control" id="company" name="company" placeholder="Enter Company, Organization, or School">
                </div>


                <!-- BEGIN: Message Text (text area) -->

                <div class="col-12">

                  <div class="form-group">
                    <label for="message" class="font-oswald col-form-label text-dark-blue text-size-h3">Message<span class="text-hot-pink text-size-h2">&#42;</span></label>
                    <textarea class="form-control" id="message" name="message" rows="4" placeholder="Type An Encouraging Message" required></textarea>
                  </div>

                </div>

                <!-- END: Message Text (text area) -->


            </form>

          </div> <!-- modal-body -->

        <!-- ******* END: MODAL BODY/FORM ******* -->


        <!-- ******* BEGIN: MODAL FOOTER ******* -->

        <div class="modal-footer">

            <div id="resultTextDiv" class="row col-12 p-0">
                <p id="resultText" class="serif-heading bold text-size-h3 text-center"></p>
            </div>
            
            <div class="row">
              <button id="submitWordsButton" type="submit" class="btn">
                <span id="wordsButtonText" class="font-oswald text-white text-size-h4">Send Words</span>
              </button>
            </div>

        </div>

        <!-- ******* END: MODAL FOOTER ******* -->


        </div> <!-- modal-content -->

      </div> <!-- modal-dialog -->

    </div> <!-- modal -->

    `
  }
}

customElements.define('encourage-popup', EncouragePopup);


var wordsModalBtns = document.querySelectorAll(".leave-words-btn");


// ********* Define Modal Elements ***************** //

var wordsModal = document.getElementById("words-modal");
const xButton = document.getElementById('words-close');

const submitWordsButton = document.getElementById('submitWordsButton');
const wordsButtonText = document.getElementById('wordsButtonText');

const resultTextDiv = document.getElementById('resultTextDiv');
const resultText = document.getElementById('resultText');

const wordsForm = document.getElementById('wordsForm');


// ********* Listen & Open Encouraging Words Modal ***************** //

function openModal(event) {

    //console.log("Modal Button Clicked");

    wordsModal.style.display = "block";
}


// Add event listeners to all buttons

wordsModalBtns.forEach(function(btn) {

    btn.addEventListener("click", openModal);
});


// ********* Listen & Close Encouraging Words Modal ***************** //

function closeModal() {
  
    wordsModal.style.display = "none";

    resultText.innerText = "";

    wordsButtonText.innerText = "Send Words";

    submitWordsButton.disabled = false;
}

xButton.addEventListener("click", () => {

    //console.log("Close Modal Button Clicked");

    form.reset();

    closeModal();
    
});

/**************************************** Send Modal Form Data To Google Sheets ************************************/
	
const scriptURL = 'https://script.google.com/macros/s/AKfycbzdiwd8TN3PGwuBVVVQlNKSo26deFDHTAR6U-gJUQZqYnlTrl2DMr9AXnObIQm0kOuMYw/exec'

const form = document.forms['wordsForm']

const firstName = document.getElementById('firstName');
const lastName = document.getElementById('lastName');
const city = document.getElementById('city');
const state = document.getElementById('state');
const title = document.getElementById('title');
const company = document.getElementById('company');
const message = document.getElementById('message');
	

submitWordsButton.addEventListener('click',  e => {
    
    e.preventDefault()

    // console.log('Trying to submit to Google Sheets');

    resultTextDiv.style.display = "none";

    wordsButtonText.innerText = "Sending...";

    //console.log('FirstName: ', firstName.value.trim());
    // console.log('LastName: ', lastName.value.trim());
    // console.log('City: ', city.value.trim());
    // console.log('State: ', state.value.trim());
    // console.log('Title: ', title.value.trim());
    // console.log('Company: ', company.value.trim());
    // console.log('Message: ', message.value.trim());

    let firstNameValue = firstName.value.trim();
    let lastNameValue = lastName.value.trim();
    let cityValue = city.value.trim();
    let stateValue = state.value.trim();
    let titleValue = title.value.trim();
    let companyValue = company.value.trim();
    let messageValue = message.value.trim();

    if (!firstNameValue) { 

        wordsButtonText.innerText = "Send Words";

        resultTextDiv.style.display = "block";

        resultText.innerText = "First Name is required.";

        return

    } else if (!lastNameValue) {

        wordsButtonText.innerText = "Send Words";

        resultTextDiv.style.display = "block";

        resultText.innerText = "Last Name is required.";

        return

    } else if (!cityValue) {

        wordsButtonText.innerText = "Send Words";

        resultTextDiv.style.display = "block";

        resultText.innerText = "City is required.";

        return

    } else if (!stateValue) {

        wordsButtonText.innerText = "Send Words";

        resultTextDiv.style.display = "block";

        resultText.innerText = "State or Country is required.";

        return

    } else if (!messageValue) {

        wordsButtonText.innerText = "Send Words";

        resultTextDiv.style.display = "block";

        resultText.innerText = "A message is required.";

        return
    }


    fetch(scriptURL, { 
        method: 'POST', 
        body: new FormData(form)
    })

    .then(response => {

        resultTextDiv.style.display = "block";

        resultText.innerText = "Thank you! We will post your words soon.";

        wordsButtonText.innerText = "Sent";

        submitWordsButton.disabled = true;

        form.reset();

    })

    .catch((error) => {

        wordsButtonText.innerText = "Send Encouragement";

        resultText.style.display = "block";

        resultText.innerText = "An error occured. Please try again later.";
    })
})
